// extracted by mini-css-extract-plugin
export default {"base_img":"cropImage_base_img__hVkcB","cropper_container":"cropImage_cropper_container__M3i44"};